import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

import config from '../../config';

const AuthProcessorButton = ({
  processor,
  identityValidator,
  processorName,
  countryCode,
  mode,
  handleClick,
  fullWidth,
}) => {
  const history = useHistory();

  const handleOnClick = () => {
    if (!!handleClick) {
      handleClick();
    } else {
      switch (processor) {
        case 'egreement':
          const authProcessorPath =
            config.REACT_APP_IDENTITY_BASE_URL +
            config.REACT_APP_AUTH_PROCESSOR_URL;
          const authProperties = (
            '?tenant=' +
            config.REACT_APP_TENANT +
            '&companyName=' +
            config.REACT_APP_AUTH_PROCESSOR_COMPANYNAME +
            '&cancelUri=' +
            config.REACT_APP_AUTH_PROCESSOR_CANCELLINK +
            '&rejectUri=' +
            config.REACT_APP_AUTH_PROCESSOR_REJECTLINK +
            '&successUri=' +
            config.REACT_APP_AUTH_PROCESSOR_RETURNLINK
          )
            .split('://')
            .join('%3A%2F%2F')
            .split('/')
            .join('%2F');

          window.location.assign(authProcessorPath + authProperties);
          break;

        case 'banksign':
        case 'freja':
        case 'signicat':
        case 'zignsec':
          history.push(
            '/auth/processor/' +
              processor +
              '?authprocessormode=' +
              mode +
              '&countryCode=' +
              countryCode
          );
          break;

        default:
          break;
      }
    }
  };

  let modeTitle = '';
  switch (mode) {
    case 'login':
      modeTitle = 'Login';
      break;
    case 'linking':
      modeTitle = 'Link';
      break;
    default:
      modeTitle = 'Sign-in';
      break;
  }

  const withStartIcon = ['signicat', 'zignsec'].includes(processor);

  return (
    <Button
      fullWidth={fullWidth}
      size="large"
      variant="contained"
      color="whiteColor"
      sx={{ textTransform: 'none' }}
      startIcon={
        withStartIcon ? (
          <img
            src={`/assets/images/auth/identity-validator/${identityValidator}.png`}
            alt=""
            style={{ maxHeight: '25px' }}
          />
        ) : (
          <img
            src={`/assets/images/auth/processor/${processor}/logo.png`}
            alt=""
            style={{ maxHeight: '25px' }}
          />
        )
      }
      onClick={handleOnClick}
    >
      {`${modeTitle} with ${processorName}`}
    </Button>
  );
};

export default AuthProcessorButton;
